import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  OrganizationChartListResponse,
  DeptCreateRequest,
  DeptUpdateRequest,
  DeptManagerCreateRequest,
  DeptManagerUpdateRequest,
  DeptManagerEmployeeListRequest,
  DeptManagerEmployeeListResponse,
  DeptManagerDeleteRequest,
  OrganizationChart,
  DeptManagers,
} from "./types";

/**
 * List
 */
export const organizationChartListService = () =>
  RestAPIClient.call<OrganizationChartListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create Dept
 */
export const organizationChartCreateDeptService = (data: DeptCreateRequest) =>
  RestAPIClient.call<OrganizationChart>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.CreateDept}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update Dept
 */
export const organizationChartUpdateDeptService = (data: DeptUpdateRequest) =>
  RestAPIClient.call<OrganizationChart>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.UpdateDept}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Delete Dept
 */
export const organizationChartDeleteDeptService = (data: {
  departmentId: number;
}) =>
  RestAPIClient.call<OrganizationChart>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.DeleteDept}/${data.departmentId}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create Dept Manager
 */
export const organizationChartCreateDeptManagerService = (
  data: DeptManagerCreateRequest
) =>
  RestAPIClient.call<DeptManagers>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.CreateDept}/${data.departmentId}/manager`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update Dept Manager
 */
export const organizationChartUpdateDeptManagerService = (
  data: DeptManagerUpdateRequest
) =>
  RestAPIClient.call<DeptManagers>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.UpdateDept}/${data.departmentId}/manager/${data.employeeId}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Delete Dept Manager
 */
export const organizationChartDeleteDeptManagerService = (
  data: DeptManagerDeleteRequest
) =>
  RestAPIClient.call<DeptManagers>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.UpdateDept}/${data.departmentId}/manager/${data.employeeId}/${data.role}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Get list employee
 */
export const organizationChartEmployeeListService = (
  data: DeptManagerEmployeeListRequest
) =>
  RestAPIClient.call<DeptManagerEmployeeListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.CreateDept}/${data.departmentId}/employees`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
